import React, { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { fetchYears } from "../lib/api";
import { MONTHS_IT } from "../lib/format";

const ALL = "__all__";

export default function PeriodFilter({ year, month, onChange, includePerson = false, person, onPersonChange, idPrefix = "period" }) {
  const [years, setYears] = useState([]);

  useEffect(() => {
    fetchYears().then((ys) => {
      const list = ys.length > 0 ? ys : [new Date().getFullYear()];
      setYears(list);
    });
  }, []);

  return (
    <div className="flex flex-wrap items-center gap-3" data-testid={`${idPrefix}-filter`}>
      <span className="text-xs uppercase tracking-widest text-stone-500">Periodo</span>
      <Select
        value={year ? String(year) : ALL}
        onValueChange={(v) => onChange({ year: v === ALL ? undefined : Number(v), month })}
      >
        <SelectTrigger className="w-[140px] rounded-xl bg-white border-stone-200" data-testid={`${idPrefix}-year`}>
          <SelectValue placeholder="Anno" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL} data-testid={`${idPrefix}-year-all`}>Tutti gli anni</SelectItem>
          {years.map((y) => (
            <SelectItem key={y} value={String(y)} data-testid={`${idPrefix}-year-${y}`}>{y}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={month ? String(month) : ALL}
        onValueChange={(v) => onChange({ year, month: v === ALL ? undefined : Number(v) })}
      >
        <SelectTrigger className="w-[160px] rounded-xl bg-white border-stone-200" data-testid={`${idPrefix}-month`}>
          <SelectValue placeholder="Mese" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL} data-testid={`${idPrefix}-month-all`}>Tutto l&apos;anno</SelectItem>
          {MONTHS_IT.map((m, i) => (
            <SelectItem key={m} value={String(i + 1)} data-testid={`${idPrefix}-month-${i + 1}`}>{m}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {includePerson && (
        <Select
          value={person || ALL}
          onValueChange={(v) => onPersonChange(v === ALL ? undefined : v)}
        >
          <SelectTrigger className="w-[160px] rounded-xl bg-white border-stone-200" data-testid={`${idPrefix}-person`}>
            <SelectValue placeholder="Persona" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL} data-testid={`${idPrefix}-person-all`}>Tutti</SelectItem>
            <SelectItem value="Madda" data-testid={`${idPrefix}-person-madda`}>Madda</SelectItem>
            <SelectItem value="Doio" data-testid={`${idPrefix}-person-doio`}>Doio</SelectItem>
            <SelectItem value="Famiglia" data-testid={`${idPrefix}-person-famiglia`}>Famiglia (split)</SelectItem>
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
